import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useDialog, useSearch, useRequestState } from '@app/hooks';
import { useTable } from '@app/components';
import { useAuthRolePermissions } from '@app/utils';
import { PortfolioList } from './portfolio-list';
import { AddPortfolio } from './add-portfolio';
import { getPortfolio } from '../slice';
import { selectPortfolioState } from '../selector';
export const PortfolioPage = () => {
  const addPortfolioDialog = useDialog();
  const tableProps = useTable();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPortfolio());
  }, [dispatch]);

  const { data, loading } = useRequestState({
    stateSelector: selectPortfolioState,
    errorShown: true,
  });

  const searchProps = useSearch({
    data,
    fields: ['name', 'category', 'id'],
  });

  const { hasPermission } = useAuthRolePermissions();
  const canAddPortfolio = hasPermission('Portfolio', 'w');

  return (
    <>
      <Header
        title={Strings.portfolio.portfolio}
        helperText={''}
        actionButtonTitle={Strings.portfolio.addPortfolio}
        onClickActionButton={addPortfolioDialog.show}
        searchBarProps={{
          placeholder: Strings.common.search,
          onChange: searchProps.handleSearchChange,
        }}
      />
      <PortfolioList
        tableProps={tableProps}
        rows={searchProps.filteredRows}
        loading={loading}
        canAddPortfolio={canAddPortfolio}
      />

      {addPortfolioDialog.visible && <AddPortfolio open onClose={addPortfolioDialog.hide} />}
    </>
  );
};
